const normalizeTestId = (identifier: string, suffix?: string) => {
  const trimmedIdentifier = identifier.trim()
  const trimmedSuffix = (suffix ?? "").trim()

  if (trimmedIdentifier.length === 0) return null
  if (trimmedSuffix.length === 0) return trimmedIdentifier

  return trimmedIdentifier + trimmedSuffix
}

export { normalizeTestId }
